import React from "react";
import { motion } from "framer-motion";

const ABOUT_IMG = "https://customer-assets.emergentagent.com/job_karnival-preview/artifacts/j2ilg9uh_image.png";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-[#070707]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-10 md:gap-16 items-stretch">
        {/* Image column */}
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9 }}
          className="md:col-span-5 relative flex"
        >
          <div className="relative overflow-hidden rounded-sm w-full min-h-[480px] md:min-h-full">
            <img
              src={ABOUT_IMG}
              alt="Karnival cold sparks first dance — bride and groom embracing in fog and sparkler fountains"
              className="absolute inset-0 w-full h-full object-cover object-center"
              data-testid="about-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
          </div>
          <div className="absolute -bottom-6 -right-6 hidden md:block">
            <div className="bg-[#FFFFFF] text-black px-6 py-5 rounded-sm">
              <div className="font-serif text-3xl leading-none">7+</div>
              <div className="text-[10px] uppercase tracking-[0.2em] mt-1">
                Years of Magic
              </div>
            </div>
          </div>
        </motion.div>

        {/* Text column */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="md:col-span-7"
        >
          <div className="flex items-center gap-3 mb-6">
            <div className="h-px w-10 bg-[#FFFFFF]" />
            <span className="text-xs uppercase tracking-[0.28em] text-[#FFFFFF]">
              Who We Are
            </span>
          </div>

          <h2
            data-testid="about-headline"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] text-white tracking-tight"
          >
            Ottawa&rsquo;s go-to team for{" "}
            <span className="italic text-[#FFFFFF]">extraordinary</span>{" "}
            experiences.
          </h2>

          <div className="mt-8 space-y-5 text-white/70 text-base md:text-lg leading-relaxed max-w-2xl">
            <p data-testid="about-p1">
              Karnival Events &amp; Entertainment specializes in transforming
              ordinary venues into extraordinary experiences — whether it&rsquo;s
              an intimate birthday celebration, a large-scale corporate gala, or
              a wedding night you&rsquo;ll never forget.
            </p>
            <p data-testid="about-p2">
              From the first beat of music to the last sparkle of a special
              effect, our team handles every detail so you don&rsquo;t have to.
              We combine professional-grade audiovisual technology with artistic
              décor and curated entertainment to deliver events that leave a
              lasting impression.
            </p>
            <p data-testid="about-p3" className="text-white/90">
              Based in Ottawa, Ontario, we proudly serve the National Capital
              Region and beyond.
            </p>
          </div>

          <div className="mt-10 flex flex-wrap gap-8 border-t border-white/10 pt-8">
            {[
              "Weddings",
              "Corporate Galas",
              "Private Parties",
              "Milestones",
            ].map((tag) => (
              <div
                key={tag}
                className="text-sm text-white/60 flex items-center gap-2"
              >
                <span className="w-1.5 h-1.5 rounded-full bg-[#FFFFFF]" />
                {tag}
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
